import React, { useEffect } from 'react';
import { initializeScrolTop } from 'utils/dom';
import Modal2 from 'components/commons/modal/Modal2';

export const TargetAssociatedAlertModal = ({
  linkToAnotherTargetTitles,
  hide,
  isShow,
  onCancel,
  onRegisterWithNewTarget,
}: {
  isShow: boolean;
  hide: () => void;
  onRegisterWithNewTarget: () => void;
  onCancel: () => void;
  linkToAnotherTargetTitles: string[];
}): React.ReactElement => {
  useEffect(() => {
    initializeScrolTop();
  }, []);
  return (
    <>
      <Modal2
        {...{
          isShow,
          close: hide,
        }}>
        <div className="p-4">
          <div className="flex flex-col text-bluegray-700 max-h-modal overflow-y-auto">
            <div className="flex flex-row">
              <div
                className="icon-close ml-auto text-gray-500 cursor-pointer"
                onClick={hide}
              />
            </div>
            <div className="flex flex-row">
              <div
                className="text-xl icon-alert"
                style={{ color: '#ffcb49' }}></div>
              <div className="ml-2 mr-auto text-bluegray-700 font-bold text-lg">
                別の目標に登録されています
              </div>
            </div>
          </div>

          <div className="mt-4 text-sm text-bluegray-700">
            {linkToAnotherTargetTitles.length === 1 ? 'この' : 'これらの'}
            口座は以下の目標に登録中です。
          </div>

          <div className="mt-4 text-base font-bold text-bluegray-700 flex-col flex gap-2">
            {linkToAnotherTargetTitles.map((title, i) => (
              <div key={i}>{title}</div>
            ))}
          </div>

          <div className="mt-4 text-bluegray-700 text-sm">
            この目標から登録をはずして、現在操作中の目標に付け替えますか？
          </div>
          <div className="mt-4 text-red-600 text-sm">
            <div>【ご注意】</div>
            <div>
              目標を付け替えると、上記の目標の「進捗」や「貯め方」が変わる可能性があります。また「除外金額」はリセットされます。
            </div>
          </div>

          <div className="mt-4 p-4 flex flex-col">
            <button
              className="rounded-lg bg-tradewell font-bold text-white text-base flex items-center justify-center py-2"
              onClick={onRegisterWithNewTarget}>
              新しい目標に登録する
            </button>
            <button
              className="bg-white py-2 flex items-center justify-center text-sm text-bluegray-500"
              onClick={onCancel}>
              キャンセル
            </button>
          </div>
        </div>
      </Modal2>
    </>
  );
};
